import { render, staticRenderFns } from "./ShiftPatternDetail.vue?vue&type=template&id=55320f7c"
import script from "../../controllers/shift_pattern/shift-pattern-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/shift_pattern/shift-pattern-detail.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports